/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ports: NonNullable<unknown> }} Home_Hero_LeadInputs */



/**
* | output |
* | --- |
* | "Master Mariners and Chief Engineers attending tankers, bulk carriers, barges and offshore units in more than {ports} ports." |
*
* @param {Home_Hero_LeadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_hero_lead = /** @type {((inputs: Home_Hero_LeadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_LeadInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`我们的船长和轮机长在超过 ${i?.ports} 个港口登轮检查油轮、散货船、驳船和海上装置。`)
	return /** @type {LocalizedString} */ (`Master Mariners and Chief Engineers attending tankers, bulk carriers, barges and offshore units in more than ${i?.ports} ports.`)
});